<app-card>
	<ul class="categories-list">
		<li class="d-flex" *ngFor="let product of topProducts">
			<div class="bg-light">
				<div class="product-content">
					<div class="order-image">
						<img [src]="product.image" [alt]="product.category_name" ngSrcset="100w, 200w" />
					</div>
				</div>
			</div>
			<div>
				<h6 class="mb-0">
					<a>
						{{ product.category_name }}
					</a>
				</h6>
				<span class="f-light f-12 f-w-500">({{ product.total_items | number }})</span>
			</div>
		</li>
	</ul>
</app-card>
